import PageSeo from '@/seo/PageSeo';
import Login from '../Login';
import LoginSso from './LoginSso';

type LoginPageProps = { isSso?: boolean };

export default function LoginPage({ isSso = false }: LoginPageProps) {
  return (
    <>
      <PageSeo
        title="Login | DISGENET"
        description="Log in to your DISGENET account."
        path={isSso ? '/sso' : '/login'}
        noindex
      />
      <div>{isSso ? <LoginSso /> : <Login />}</div>
    </>
  );
}
